<hr />
<form [formGroup]="form">
  <div class="description-container">
    <div class="audit-field">
      <strong>{{ 'AUDIT.CREATED_BY' | translate }} : </strong>
      <span class="value-container">{{ form.get('createdByName')?.value }}</span>
    </div>
    <div class="vertical-divider"></div>

    <div class="audit-field">
      <strong>{{ 'AUDIT.CREATED_DATE' | translate }} : </strong>
      <span class="value-container">{{ form.get('createdDate')?.value }}</span>
    </div>
    <div class="vertical-divider"></div>

    <div class="audit-field">
      <strong>{{ 'AUDIT.LAST_MODIFIED_BY' | translate }} : </strong>
      <span class="value-container">{{ form.get('lastModifiedByName')?.value }}</span>
    </div>
    <div class="vertical-divider"></div>

    <div class="audit-field">
      <strong>{{ 'AUDIT.LAST_MODIFIED_DATE' | translate }} : </strong>
      <span class="value-container">{{ form.get('lastModifiedDate')?.value }}</span>
    </div>
  </div>
</form>
